import { parseVersion } from '@amazon/vinyl-util'

export const bullfrogVersion = parseVersion(process.env.BULLFROG_VERSION ?? '0.0.0.0')
;(global as any).version = bullfrogVersion.str
